export function renderPopup ( shouldComponentRender, Component ) {
    return shouldComponentRender ? Component : null
}